import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { InvestmentDashboard } from '../modules/investment/InvestmentDashboard';
import { BondDashboard } from '../modules/bonds/BondDashboard';
import { Settings } from '../modules/settings/Settings';
import { HelpSupport } from '../modules/help/HelpSupport';
// import { LandingPage } from '../components/auth';
import { Login } from '../components/auth';
import { SignUp } from '../components/auth';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user } = useAuth();
    return user ? children : <Navigate to="/login" replace />;
};

export const AppRouter = () => {
    const { user } = useAuth();

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
            <Route path="/signup" element={user ? <Navigate to="/dashboard" replace /> : <SignUp />} />

            {/* Protected Routes */}
            <Route path="/dashboard" element={
                <ProtectedRoute>
                    <Navigate to="/bonds" replace />
                </ProtectedRoute>
            } />
            <Route path="/bonds" element={
                <ProtectedRoute>
                    <BondDashboard />
                </ProtectedRoute>
            } />
            <Route path="/investment" element={
                <ProtectedRoute>
                    <InvestmentDashboard />
                </ProtectedRoute>
            } />
            <Route path="/settings" element={
                <ProtectedRoute>
                    <Settings />
                </ProtectedRoute>
            } />
            <Route path="/help" element={
                <ProtectedRoute>
                    <HelpSupport />
                </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};
